module.exports = __webpack_public_path__ + "static/media/products_services1.9a6c7434.jpg";